"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataReporterAdapter = void 0;
var browser_util_1 = require("../../utils/browser.util");
var ua_1 = require("../../utils/ua");
var DataReporterAdapter = (function () {
    function DataReporterAdapter(params) {
        this.registeredPlugins = [];
        try {
            this.configs = params;
            var appid = params.appid;
            this.routerParams = browser_util_1.getURLParams(window.location.search) || {};
            var clientHeight = document.body.clientHeight;
            this.userActionRaw = {
                ch: this.routerParams.ch,
                appid: appid,
                dsp_id: this.routerParams.dsp_id,
                system_platform: ua_1.isAndroid(window.navigator.userAgent) ? '2' : '1',
                platform: this.getAppPlatform().toString(),
                is_tbs: ua_1.isTBS(window.navigator.userAgent) ? '1' : '0',
                source_id: this.routerParams.source_id || '0',
                url: window.location.href || '',
                client_height: "" + clientHeight,
            };
        }
        catch (error) {
            console.log('init error', error);
        }
    }
    Object.defineProperty(DataReporterAdapter.prototype, "appId", {
        get: function () {
            return this.userActionRaw.appid;
        },
        set: function (_appId) {
            this.userActionRaw.appid = _appId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataReporterAdapter.prototype, "raw", {
        get: function () {
            return this.userActionRaw;
        },
        set: function (_raw) {
            this.userActionRaw = _raw;
        },
        enumerable: false,
        configurable: true
    });
    DataReporterAdapter.prototype.getAppPlatform = function () {
        if (ua_1.isQQBrowser(window.navigator.userAgent)) {
            return 0;
        }
        if (ua_1.isWeChat(window.navigator.userAgent)) {
            return 1;
        }
        if (ua_1.isQQ(window.navigator.userAgent)) {
            return 2;
        }
        if (ua_1.isQzone(window.navigator.userAgent)) {
            return 3;
        }
        return 4;
    };
    DataReporterAdapter.prototype.genUserActionReportData = function (data) {
        try {
            if (!data || !data.user_action) {
                return '';
            }
            data = Object.assign({}, this.userActionRaw, data, {
                timestamp: Date.now(),
            });
            var ret = window.btoa(unescape(encodeURIComponent(JSON.stringify(data))));
            return ret;
        }
        catch (error) {
            console.log(error);
            return '';
        }
    };
    DataReporterAdapter.prototype.reportUserAction = function (raw) {
        return __awaiter(this, void 0, void 0, function () {
            var data, reportUrl;
            return __generator(this, function (_a) {
                data = this.genUserActionReportData(raw);
                if (!data)
                    throw Error("invalid report data: " + data);
                reportUrl = "//ugpage.html5.qq.com/proxy/stat/reportData?data=" + encodeURIComponent(data);
                new Image().src = reportUrl;
                return [2];
            });
        });
    };
    DataReporterAdapter.prototype.register = function (Plugin, option) {
        try {
            if (!Plugin) {
                return;
            }
            if (this.registeredPlugins.some(Plugin)) {
                return;
            }
            new Plugin(this, option);
            this.registeredPlugins.push(Plugin);
        }
        catch (error) {
            throw new Error("plugin register failed" + error);
        }
    };
    return DataReporterAdapter;
}());
exports.DataReporterAdapter = DataReporterAdapter;
//# sourceMappingURL=index.js.map